import {
  TSetFavoriteOrderTypeType,
  TSetDealTypeType,
  TSetFavoriteEntityTypeType,
  TSetShowFiltersModal,
} from '../../actions/filters';

export const FILTERS_SET_DEAL_TYPE_TYPE: TSetDealTypeType = 'filters/set_deal_type';
export const FILTERS_SET_FAVORITE_ENTITY_TYPE_TYPE: TSetFavoriteEntityTypeType = 'filters/set_favorite_entity_type';
export const FILTERS_SET_ORDER_TYPE_TYPE: TSetFavoriteOrderTypeType = 'filters/set_favorite_order_type';

export const FILTERS_SET_SHOW_FILTERS_MODAL: TSetShowFiltersModal = 'filters/set_show_filters_modal';
